import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '../atom/Button';
import { Text } from '../atom/Text';
import { Flex } from '../atom/Layout';
import { InputForm } from './InputForm';

import { SIGNIN } from '../../../lib/routes/path';
import ThemeStyle from '../../../lib/style/ThemeStyle';

export const FindForm = ({
  formData = {
    title: '',
    data: [{ type: '', name: '', mainIconName: '', placeholder: '' }],
  },
  onClickButton,
  onChangeValue,
  state,
  isComplete,
  isValidateTrue,
  children,
}) => {
  const history = useHistory();

  return (
    <Flex column alignItems="stretch" padding="0 0 1.25rem">
      {!isComplete ? (
        <InputForm
          formData={formData.data}
          onChangeValue={onChangeValue}
          state={state}
          onSubmit={onClickButton}
          size={3}
        >
          <Button
            color={isValidateTrue ? 'brownGrey' : 'pinkishGrey'}
            onClick={onClickButton}
            style={{ marginTop: '1.25rem' }}
          >
            <Text>{formData.title}</Text>
          </Button>
        </InputForm>
      ) : (
        <Flex column alignItems="stretch" height="15rem">
          <Text
            style={{
              padding: '2.5rem',
              border: `1px solid ${ThemeStyle.color.pinkishGrey}`,
            }}
            color="brownGrey"
          >
            {children}
          </Text>
          <Button
            style={{
              marginTop: '1.25rem',
            }}
            onClick={() => history.push(SIGNIN)}
          >
            로그인
          </Button>
        </Flex>
      )}
    </Flex>
  );
};
